import type { UserRoleSearchRequest } from '@trukt/tms-api/UserRoleService';
import { createKey } from '../createKey';
import { PermissionsServiceKeys } from './serviceKeys';

const keyHandler = createKey('user-role');

export const UserRoleServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<UserRoleSearchRequest>(),
  permissions: PermissionsServiceKeys,
};
